var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateLessonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90527 0C12.3271 8.0171e-05 14.0184 1.66892 14.0186 4.06055V10.9395C14.0184 13.3311 12.3271 14.9999 9.90527 15H4.11328C1.69138 15 0.000173044 13.3311 0 10.9395V4.06055C0.00017282 1.66886 1.69138 0 4.11328 0H9.90527ZM17.958 2.37891C18.397 2.15559 18.9121 2.17941 19.3311 2.44336C19.7499 2.7063 20 3.16276 20 3.66211V11.3379C20 11.8384 19.75 12.2947 19.3311 12.5576C19.1021 12.7008 18.8459 12.7734 18.5879 12.7734C18.373 12.7734 18.1579 12.7235 17.957 12.6211L16.4756 11.873C15.928 11.5949 15.5881 11.037 15.5879 10.417V4.58301C15.5879 3.96178 15.9277 3.40312 16.4756 3.12695L17.958 2.37891Z",
    fill: "#F04F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLessonIcon);
export default __webpack_public_path__ + "static/media/CreateLessonIcon.762dcab04846ff30c11d9fabc3b5a006.svg";
export { ForwardRef as ReactComponent };